(function () {
  "use strict";

  var PAGE_SIZE = 8;
  var MAX_RESULTS = 200;
  var MARKER_CAP = 200;
  var SEARCH_RADIUS_MILES = 25;
  var USA_CENTER = [39.8283, -98.5795];
  var USA_ZOOM = 4;
  var SEARCH_ZOOM = 11;
  var GEO_CACHE = {};
  var PIN_ICON = null;
  var EARTH_MILES = 3958.8;
  var PRODUCT_IMAGES = {
    "Garlic Naan": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030089_Truly-Indian_Naan-Bag-Mockup_GARLIC_2cdd61bd-9811-42d3-95a5-e8b64b3fa5a7.png?v=1786962208",
    "Tandoori Naan": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030072_Truly-Indian_Naan-Bag-Mockup_TANDOORI_fb81a10f-fcce-45af-8dcc-84815d60c963.png?v=1786962263",
    "Tikka Masala Naan": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Naan-Bag-Mockup_TIKKA-20251010_a6e032ad-3fe5-4bb9-bd0b-d7424fe8be86.png?v=1786962271",
    "Butter Chik'n Naan": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Naan-Bag-Mockup_BUTTER-CHIKN-20260120_b99beed2-5265-4591-b259-f1335f2501e4.png?v=1786962165",
    "Green Chili Naan": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Naan-Bag-Mockup_GREEN-CHILI-20250723_b5b09638-8dc7-452b-8eae-76f9854bfa4e.png?v=1786962213",
    "Paneer Tikka Wrap": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030010_Truly-Indian_Street-Wrap-Mockup_PANEER-TIKKA_4118d441-b2c3-4a8f-a913-847661389deb.png?v=1786962240",
    "Tandoori Potato Wrap": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030027_Truly-Indian_Street-Wrap-Mockup_TANDOORI-ALOO_ff003b59-47ef-489d-8acc-799c9e8789f4.png?v=1786962259",
    "Aloo Gobi Wrap": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030034_Truly-Indian_Street-Wrap-Mockup_ALOO-GOBI_583e654e-95ec-4976-b384-97688ee962d7.png?v=1786962174",
    "Dal Makhani": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030294_Truly-Indian_Ready-to-Eat-Pouch_mockup_DAL-MAKHANI_a8927a15-c83b-430b-9322-4517fb88e21b.png?v=1786962204",
    "Chana Masala": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030300_Truly-Indian_Ready-to-Eat-Pouch_mockup_CHANA-MASALA_bb45d441-ba8b-4a27-9d12-ac7f7c698205.png?v=1786962195",
    "Palak Tofu Paneer": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030324_Truly-Indian_Ready-to-Eat-Pouch_mockup_PALAK-TOFU-PANEER_d2bee70a-2fa7-474d-9207-8af8e61b9dae.png?v=1786962236",
    "Aloo Matar": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030317_Truly-Indian_Ready-to-Eat-Pouch_mockup_ALOO-MATAR_49723999-d3d6-4f7a-b2d4-15502db6460a.png?v=1786962178",
    "Bombay Biryani Rice": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030270_Truly-Indian_Ready-to-Eat-Pouch_mockup_BOMBAY-BIRYANI_937a2217-ab64-4e5d-9893-aa045844b1bc.png?v=1786962186",
    "Tikka Masala Rice": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030263_Truly-Indian_Ready-to-Eat-Pouch_mockup_TIKKA-MASALA-RICE_d608dc7d-2cca-47e3-a303-d494ee557fdc.png?v=1786962275",
    "Butter Chicken Sauce": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030232_Truly-Indian_Sauce-Mockup_BUTTER-CHICKEN_32c61979-e779-4a5e-99f5-b987157359a3.png?v=1786962191",
    "Tikka Masala Sauce": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030249_Truly-Indian_Sauce-Mockup_TIKKA-MASALA_5ebd8b37-417e-4894-8c32-c3664751b635.png?v=1786962280",
    "Madras Curry Sauce": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030225_Truly-Indian_Sauce-Mockup_MADRAS-CURRY_2090b4c7-bcfb-4871-963e-1beab5c68ae7.png?v=1786962221",
    "Potato & Pea Samosas": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/767532030065_Truly-Indian_Samosa-Box-mockup_37714712-3fe4-4161-8697-f72ab5e0aa2a.png?v=1786962245",
    "Crunchy Chili Mango Chutney": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Chutney-Jar-Mockup_CRISPY-CHILI-MANGO-20250723_549be1cc-5220-4995-ad7f-83b1849ba17d.png?v=1786962199",
    "Mango Ginger Chutney": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Chutney-Jar-Mockup_MAJOR-GREY-20250723_4a3c29f4-4e1f-420d-af3f-d79058c4bf5e.png?v=1786962225",
    "Sweet Mango Chutney": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Chutney-Jar-Mockup_SWEET-MANGO-20250723_822ba708-cdef-4a5d-b88b-cbb0b0bb2e4f.png?v=1786962250",
    "Tamarind & Dates Chutney": "https://cdn.shopify.com/s/files/1/0765/9375/8399/files/Truly-Indian_Chutney-Jar-Mockup_SWEET-TAMARIND-20250723_d134032f-e702-4830-acf4-6e9d546a6032.png?v=1786962254"
  };
  var PRODUCT_ONLINE = {
    "Garlic Naan": [
      ["Amazon", "https://www.amazon.com/dp/B0D6891P33", "amazon"],
      ["Instacart", "https://www.instacart.com/products/51758640-truly-indian-tandoori-garlic-naan-12-0-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-garlic-naan-12-oz/urpc_15ceed4d-c060-485e-8166-667a77dc53c5", "doordash"]
    ],
    "Tandoori Naan": [
      ["Amazon", "https://www.amazon.com/dp/B0D689ZPN2", "amazon"],
      ["Instacart", "https://www.instacart.com/products/48879329-ti-tandoori-naan-12-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-tandoori-naan-12-oz/urpc_834633c4-8bcc-4f20-bfa7-9413e6c9c9b1", "doordash"]
    ],
    "Tikka Masala Naan": [
      ["DoorDash", "https://www.doordash.com/products/truly-indian-tikka-masala-naan-10-6-oz/ugp_ce2f64e6-1351-4b9f-8efc-8046afa18efa", "doordash"]
    ],
    "Butter Chicken Sauce": [
      ["Amazon", "https://www.amazon.com/dp/B0DJRSFBFW", "amazon"],
      ["Instacart", "https://www.instacart.com/products/48435018-butter-chicken-sauce-1-each", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-creamy-tomato-butter-chicken-sauce-13-oz/ugp_8dce1432-f053-4355-8842-cd17af551559", "doordash"]
    ],
    "Tikka Masala Sauce": [
      ["Amazon", "https://www.amazon.com/dp/B0DJRSRDQL", "amazon"],
      ["Instacart", "https://www.instacart.com/products/48435006-tikka-masala-sauce-1-each", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-tangy-creamy-tikka-masala-sauce-13-oz/urpc_d24727c6-5b5f-4b62-a3f2-43222c93228d", "doordash"]
    ],
    "Madras Curry Sauce": [
      ["Amazon", "https://www.amazon.com/dp/B0DJRR8PT3", "amazon"],
      ["Instacart", "https://www.instacart.com/products/51698068-truly-indian-madras-curry-sauce-vegan-13-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-madras-curry-sauce-13-oz/urpc_7c03b212-9a8c-4851-9f86-71d9ade50eab", "doordash"]
    ],
    "Tikka Masala Rice": [
      ["Amazon", "https://www.amazon.com/dp/B0DJTFRQ65", "amazon"],
      ["Instacart", "https://www.instacart.com/products/49027396-ti-tikka-masala-rice-7-05-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-tangy-tomato-tikka-masala-rice-10-oz/urpc_0eed1023-60da-4e1c-8583-0a9e1f317e5a", "doordash"]
    ],
    "Bombay Biryani Rice": [
      ["Amazon", "https://www.amazon.com/dp/B0DJV8RZCJ", "amazon"],
      ["Instacart", "https://www.instacart.com/products/49028082-ti-bombay-biryani-rice-7-05-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-spiced-rice-veggie-bombay-biryani-7-05-oz/urpc_3794d9a3-3949-45fd-b97b-b8497dd227d4", "doordash"]
    ],
    "Aloo Matar": [
      ["Amazon", "https://www.amazon.com/dp/B0DJV7ZQXR", "amazon"],
      ["Instacart", "https://www.instacart.com/products/51872385-truly-indian-potato-pea-curry-aloo-matar-vegan-10-0-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-potato-pea-aloo-matar-curry-10-oz/urpc_70be8169-d14b-4d81-b52d-d1f8e0287828", "doordash"]
    ],
    "Chana Masala": [
      ["Amazon", "https://www.amazon.com/dp/B0DJV7YFD1", "amazon"],
      ["Instacart", "https://www.instacart.com/products/49027169-truly-indian-entree-curried-chickpeas-10-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-restaurant-style-mild-curried-chickpeas-10-oz/urpc_2c8e1beb-f68d-400f-afa1-fd5119a59b9e", "doordash"]
    ],
    "Palak Tofu Paneer": [
      ["Amazon", "https://www.amazon.com/dp/B0DJV68H72", "amazon"],
      ["Instacart", "https://www.instacart.com/products/49027609-ti-creamed-spinach-tofu-entree-10-oz", "instacart"]
    ],
    "Dal Makhani": [
      ["Amazon", "https://www.amazon.com/dp/B0DJV2C739", "amazon"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-dal-makhani-mild-lentil-bean-chili-10-oz/urpc_83bed770-1fe1-44d5-9e62-63d5450cde2a", "doordash"]
    ],
    "Potato & Pea Samosas": [
      ["Instacart", "https://www.instacart.com/products/48882122-ti-vegetable-samosa-14-8-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-vegan-punjabi-style-spiced-potato-pea-samosa-14-8-oz/urpc_3d3c39af-0b1f-4885-b1bd-bb91954bb12e", "doordash"]
    ],
    "Paneer Tikka Wrap": [
      ["Instacart", "https://www.instacart.com/products/48882078-ti-roti-wrap-marinated-cottage-cheese-5-29-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-paneer-tikka-street-wrap-5-29-oz/urpc_a9268505-521b-4cfb-92a5-208a3a314ec8", "doordash"]
    ],
    "Tandoori Potato Wrap": [
      ["Instacart", "https://www.instacart.com/products/48882127-ti-roti-tandoori-spiced-potato-5-29-oz", "instacart"],
      ["DoorDash", "https://www.doordash.com/products/truly-indian-tandoori-spiced-potato-roti-wrap-5-29-oz/urpc_c39279a2-cdb9-4643-8162-18ce4d76ca40", "doordash"]
    ],
    "Aloo Gobi Wrap": [
      ["DoorDash", "https://www.doordash.com/products/truly-indian-spiced-cauliflower-potato-aloo-gobi-roti-wrap-5-29-oz/urpc_5012c0d4-3ad8-435d-996a-2035b0151ede", "doordash"]
    ]
  };

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function normalize(str) {
    return String(str || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function zipDigits(zip) {
    return String(zip || "").replace(/\D/g, "");
  }

  function titleCaseCity(city) {
    return String(city || "")
      .toLowerCase()
      .replace(/\b([a-z])/g, function (m) {
        return m.toUpperCase();
      });
  }

  function storeAddress(store) {
    return [store.a, store.a2, store.c, store.s, store.z, "USA"].filter(Boolean).join(", ");
  }

  function mapsUrl(store) {
    return (
      "https://www.google.com/maps/search/?api=1&query=" +
      encodeURIComponent(storeAddress(store))
    );
  }

  function storeProducts(store) {
    return Array.isArray(store.p) ? store.p.filter(Boolean) : [];
  }

  function storeInitials(name) {
    var clean = String(name || "")
      .replace(/[#0-9]/g, " ")
      .replace(/\b(alb|carrs|market|store|the|of|and)\b/gi, " ")
      .trim();
    var parts = clean.split(/\s+/).filter(Boolean);
    if (!parts.length) return "TI";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  function waitForLeaflet(cb) {
    if (window.L) {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.L || tries > 40) {
        clearInterval(timer);
        if (window.L) cb();
      }
    }, 100);
  }

  function getPinIcon(pinUrl) {
    if (PIN_ICON || !window.L) return PIN_ICON;
    var url = pinUrl || "";
    PIN_ICON = window.L.divIcon({
      className: "store-locator-finder__pin-marker",
      html:
        '<img class="store-locator-finder__pin-heart" src="' +
        url +
        '" alt="" width="26" height="26" decoding="async" aria-hidden="true">',
      iconSize: [26, 26],
      iconAnchor: [13, 26],
      popupAnchor: [0, -22],
    });
    return PIN_ICON;
  }

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  function milesBetween(a, b) {
    if (!a || !b || a.lat == null || b.lat == null) return 1 / 0;
    var dLat = toRad(b.lat - a.lat);
    var dLng = toRad(b.lng - a.lng);
    var lat1 = toRad(a.lat);
    var lat2 = toRad(b.lat);
    var h =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * EARTH_MILES * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function storePoint(store) {
    return store && typeof store.lat == "number" && typeof store.lng == "number"
      ? { lat: store.lat, lng: store.lng }
      : null;
  }

  var STATE_NAMES = {
    al: "alabama",
    ak: "alaska",
    az: "arizona",
    ar: "arkansas",
    ca: "california",
    co: "colorado",
    ct: "connecticut",
    de: "delaware",
    dc: "district of columbia",
    fl: "florida",
    ga: "georgia",
    hi: "hawaii",
    id: "idaho",
    il: "illinois",
    in: "indiana",
    ia: "iowa",
    ks: "kansas",
    ky: "kentucky",
    la: "louisiana",
    me: "maine",
    md: "maryland",
    ma: "massachusetts",
    mi: "michigan",
    mn: "minnesota",
    ms: "mississippi",
    mo: "missouri",
    mt: "montana",
    ne: "nebraska",
    nv: "nevada",
    nh: "new hampshire",
    nj: "new jersey",
    nm: "new mexico",
    ny: "new york",
    nc: "north carolina",
    nd: "north dakota",
    oh: "ohio",
    ok: "oklahoma",
    or: "oregon",
    pa: "pennsylvania",
    ri: "rhode island",
    sc: "south carolina",
    sd: "south dakota",
    tn: "tennessee",
    tx: "texas",
    ut: "utah",
    vt: "vermont",
    va: "virginia",
    wa: "washington",
    wv: "west virginia",
    wi: "wisconsin",
    wy: "wyoming",
  };

  function looksLikeZip(query) {
    var compact = String(query || "").replace(/\s+/g, "");
    var digits = zipDigits(query);
    return (
      /^\d{5}(-\d{0,4})?$/.test(compact) ||
      (digits.length >= 5 && digits.length <= 9 && /^\d[\d\s-]*$/.test(query))
    );
  }

  function extractZip(query) {
    var matches = String(query || "").match(/\b\d{5}(?:-\d{4})?\b/g);
    if (!matches || !matches.length) return "";
    return matches[matches.length - 1].slice(0, 5);
  }

  function stripUnit(query) {
    return String(query || "")
      .replace(
        /(?:^|[\s,])(?:apt|apartment|unit|suite|ste|bldg|building|floor|room|rm)\.?\s*#?\s*[a-z0-9-]+/gi,
        " "
      )
      .replace(/(?:^|[\s,])#\s*[a-z0-9-]+/g, " ")
      .replace(/\s+,/g, ",")
      .replace(/\s+/g, " ")
      .trim();
  }

  function queryStateName(query) {
    var text = " " + String(query || "").toLowerCase().replace(/[^a-z\s]/g, " ").replace(/\s+/g, " ") + " ";
    var full = [];
    var abbr;
    for (abbr in STATE_NAMES) {
      if (Object.prototype.hasOwnProperty.call(STATE_NAMES, abbr)) full.push(STATE_NAMES[abbr]);
    }
    full.sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < full.length; i++) {
      if (text.indexOf(" " + full[i] + " ") !== -1) return full[i];
    }
    var re = /(?:^|[\s,])([A-Za-z]{2})(?=\s+\d{5}\b|\s*$|\s*,)/g;
    var found = "";
    var match;
    while ((match = re.exec(String(query || "")))) {
      var name = STATE_NAMES[match[1].toLowerCase()];
      if (name) found = name;
    }
    return found;
  }

  function stateAgrees(query, point) {
    var wanted = queryStateName(query);
    if (!wanted || !point || !point.state) return true;
    return String(point.state).toLowerCase() === wanted;
  }

  function cityStateQuery(query) {
    var cleaned = stripUnit(query).replace(/\b\d{5}(?:-\d{4})?\b/g, " ");
    var parts = cleaned
      .split(",")
      .map(function (part) {
        return part.replace(/\s+/g, " ").trim();
      })
      .filter(Boolean);
    if (parts.length >= 2 && /^\d/.test(parts[0])) return parts.slice(1).join(", ");
    return "";
  }

  function geocodeZip(zip) {
    var key = "zip:" + zip;
    if (GEO_CACHE[key] !== void 0) return Promise.resolve(GEO_CACHE[key]);
    return fetch("https://api.zippopotam.us/us/" + encodeURIComponent(zip))
      .then(function (res) {
        if (!res.ok) throw new Error("zip failed");
        return res.json();
      })
      .then(function (data) {
        var place = data && data.places && data.places[0];
        if (!place) {
          GEO_CACHE[key] = null;
          return null;
        }
        var point = {
          lat: parseFloat(place.latitude),
          lng: parseFloat(place.longitude),
          state: place.state || "",
        };
        GEO_CACHE[key] = point;
        return point;
      })
      .catch(function () {
        GEO_CACHE[key] = null;
        return null;
      });
  }

  function geocodeQuery(query) {
    var trimmed = String(query || "").trim();
    if (!trimmed) return Promise.resolve(null);
    var digits = zipDigits(trimmed);
    if (looksLikeZip(trimmed) && digits.length >= 5) {
      return geocodeZip(digits.slice(0, 5)).then(function (point) {
        return point || geocodeAddress(trimmed);
      });
    }
    var zip = extractZip(trimmed);
    var cleaned = stripUnit(trimmed);
    var streetQuery = cleaned || trimmed;
    return Promise.all([
      geocodeAddress(streetQuery),
      zip ? geocodeZip(zip) : Promise.resolve(null),
    ]).then(function (pair) {
      var street = pair[0];
      var zipPoint = pair[1];
      if (street && !stateAgrees(trimmed, street)) street = null;
      if (street && zipPoint) {
        if (milesBetween(street, zipPoint) <= 50) return street;
        return zipPoint;
      }
      if (street) return street;
      if (zipPoint) return zipPoint;
      var city = cityStateQuery(trimmed);
      if (!city || city === streetQuery) return null;
      return geocodeAddress(city).then(function (point) {
        if (point && !stateAgrees(trimmed, point)) return null;
        return point;
      });
    });
  }

  function searchQueryReady(query) {
    if (/^\d+$/.test(query)) return query.length >= 5;
    return query.length >= 3;
  }

  var lastClickKey = "";
  var lastClickAt = 0;
  var SESSION_KEY = "ti_wheretofind_session";
  var SEARCH_KEY = "ti_wheretofind_search";
  var LOCATOR_LOG_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSefghmj4CVu2rwzIFd2JrZvu0_lTZgFmgWZrizHZ76mMQ45yg/formResponse";

  function locatorSessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      var id = Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SESSION_KEY, id);
      return id;
    } catch (err) {
      return "";
    }
  }

  function rememberSearch(payload) {
    try {
      sessionStorage.setItem(
        SEARCH_KEY,
        JSON.stringify({
          query: payload.query || "",
          state: payload.state || "",
          product: payload.product || "",
          results: payload.results === 0 || payload.results ? String(payload.results) : "",
        })
      );
    } catch (err) {}
  }

  function lastSearch() {
    try {
      return JSON.parse(sessionStorage.getItem(SEARCH_KEY) || "null") || {};
    } catch (err) {
      return {};
    }
  }

  function sendLocatorLog(type, payload) {
    payload = payload || {};
    if (type === "search") rememberSearch(payload);
    var prior = type === "click" ? lastSearch() : {};
    var query = payload.query || prior.query || "";
    var state = payload.state || prior.state || "";
    var product = payload.product || prior.product || "";
    var results =
      payload.results === 0 || payload.results ? payload.results : prior.results || "";
    var fields = {
      "entry.763747866": type || "",
      "entry.1099249773": locatorSessionId(),
      "entry.1962784986": payload.action || (type === "search" ? "search" : ""),
      "entry.45906970": String(query).slice(0, 120),
      "entry.602112085": String(state).slice(0, 40),
      "entry.1576281329": String(product).slice(0, 120),
      "entry.647354488": results === 0 || results ? String(results) : "",
      "entry.1008473500": String(payload.store || "").slice(0, 120),
      "entry.491392636": String(payload.retailer || "").slice(0, 40),
      "entry.700711350": String(location.pathname || "").slice(0, 180),
      "entry.240317676": String(payload.detail || "").slice(0, 200),
    };
    var body = Object.keys(fields)
      .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(fields[key]);
      })
      .join("&");
    try {
      fetch(LOCATOR_LOG_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: body,
      });
    } catch (err) {}
  }

  function publishLocatorEvent(eventName, payload) {
    sendLocatorLog(eventName.indexOf("search") !== -1 ? "search" : "click", payload);
    function send() {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(eventName, payload);
        return true;
      }
      return false;
    }
    if (send()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (send() || tries > 10) clearInterval(timer);
    }, 500);
  }

  function publishLocatorSearch(payload) {
    publishLocatorEvent("truly_indian:store_locator_search", payload);
  }

  function bindClickTracking() {
    if (document.documentElement.getAttribute("data-sl-click-bound") === "1") return;
    document.documentElement.setAttribute("data-sl-click-bound", "1");
    document.addEventListener(
      "click",
      function (event) {
        var el = event.target.closest && event.target.closest("[data-sl-track]");
        if (!el) return;
        var payload = {
          action: el.getAttribute("data-sl-track") || "",
          store: String(el.getAttribute("data-sl-store") || "").slice(0, 120),
          retailer: el.getAttribute("data-sl-retailer") || "",
          product: String(el.getAttribute("data-sl-product-name") || "").slice(0, 120),
          detail: el.hasAttribute("data-sl-online") ? "search result" : "",
        };
        if (!payload.action) return;
        var key = [payload.action, payload.store, payload.retailer, payload.product].join("|");
        var now = Date.now();
        if (key === lastClickKey && now - lastClickAt < 1000) return;
        lastClickKey = key;
        lastClickAt = now;
        publishLocatorEvent("truly_indian:store_locator_click", payload);
      },
      true
    );
  }

  function geocodeAddress(address) {
    var key = normalize(address);
    if (GEO_CACHE[key]) return Promise.resolve(GEO_CACHE[key]);
    var url =
      "https://photon.komoot.io/api/?q=" +
      encodeURIComponent(address) +
      "&limit=1&lang=en&lat=39.8283&lon=-98.5795";
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("geocode failed");
        return res.json();
      })
      .then(function (data) {
        var feature = data && data.features && data.features[0];
        if (!feature || !feature.geometry || !feature.geometry.coordinates) {
          GEO_CACHE[key] = null;
          return null;
        }
        var coords = feature.geometry.coordinates;
        var props = feature.properties || {};
        var point = { lat: coords[1], lng: coords[0], state: props.state || "" };
        GEO_CACHE[key] = point;
        return point;
      })
      .catch(function () {
        GEO_CACHE[key] = null;
        return null;
      });
  }

  function productImage(name, width) {
    var src = PRODUCT_IMAGES[name];
    if (!src) return "";
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function onlineLinksHtml(name) {
    var links = PRODUCT_ONLINE[name];
    if (!links || !links.length) return "";
    return (
      '<div class="store-locator-finder__online">' +
      links
        .map(function (link) {
          return (
            '<a href="' +
            escapeHtml(link[1]) +
            '" data-sl-online data-sl-track="online_option" data-sl-retailer="' +
            escapeHtml(link[2]) +
            '" data-sl-product-name="' +
            escapeHtml(name) +
            '" target="_blank" rel="noopener noreferrer">' +
            escapeHtml(link[0]) +
            "</a>"
          );
        })
        .join("") +
      "</div>"
    );
  }

  function productButton(name) {
    var src = productImage(name, 160);
    var img = src
      ? '<img src="' + escapeHtml(src) + '" alt="" width="56" height="64" loading="lazy">'
      : "";
    return (
      '<div class="store-locator-finder__product-wrap">' +
      '<button type="button" class="store-locator-finder__product" data-sl-product-preview="' +
      escapeHtml(name) +
      '">' +
      img +
      "<span>" +
      escapeHtml(name) +
      "</span></button>" +
      onlineLinksHtml(name) +
      "</div>"
    );
  }

  function productsHtml(store) {
    var products = storeProducts(store);
    if (!products.length) return "";
    return (
      '<div class="store-locator-finder__products">' +
      '<p class="store-locator-finder__products-label">Available here</p>' +
      '<div class="store-locator-finder__product-list">' +
      products.map(productButton).join("") +
      "</div></div>"
    );
  }

  function popupProductsHtml(store) {
    var products = storeProducts(store);
    if (!products.length) return "";
    return (
      '<div class="store-locator-finder__popup-products">' +
      '<p class="store-locator-finder__popup-label">Available here</p>' +
      '<div class="store-locator-finder__product-list">' +
      products.map(productButton).join("") +
      "</div></div>"
    );
  }

  function productRenderEl() {
    var el = document.querySelector("[data-sl-product-popover]");
    if (el) return el;
    el = document.createElement("div");
    el.className = "store-locator-finder__render";
    el.setAttribute("data-sl-product-popover", "");
    el.setAttribute("role", "tooltip");
    el.hidden = true;
    el.innerHTML = '<img alt=""><p></p>';
    document.body.appendChild(el);
    return el;
  }

  function hideProductRender() {
    var el = document.querySelector("[data-sl-product-popover]");
    if (el) el.hidden = true;
  }

  function showProductRender(name, anchor) {
    var src = productImage(name, 280);
    if (!src || !anchor) return;
    var el = productRenderEl();
    var img = el.querySelector("img");
    var label = el.querySelector("p");
    img.src = src;
    img.alt = name;
    label.textContent = name;
    el.hidden = false;
    var rect = anchor.getBoundingClientRect();
    var width = 132;
    var height = el.offsetHeight || 168;
    var gap = 10;
    var left = rect.right + gap;
    var top = rect.top + rect.height / 2 - height / 2;
    if (left + width > window.innerWidth - 8) left = rect.left - width - gap;
    if (left < 8) {
      left = Math.max(8, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 8));
      top = rect.bottom + gap;
    }
    top = Math.max(8, Math.min(top, window.innerHeight - height - 8));
    el.style.left = left + "px";
    el.style.top = top + "px";
  }

  function bindProductRender() {
    if (document.documentElement.getAttribute("data-sl-render-bound") === "1") return;
    document.documentElement.setAttribute("data-sl-render-bound", "1");
    var pinned = false;
    document.addEventListener(
      "click",
      function (e) {
        var btn = e.target.closest && e.target.closest("[data-sl-product-preview]");
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          pinned = true;
          showProductRender(btn.getAttribute("data-sl-product-preview"), btn);
          return;
        }
        pinned = false;
        hideProductRender();
      },
      true
    );
    document.addEventListener("pointerover", function (e) {
      var btn = e.target.closest && e.target.closest("[data-sl-product-preview]");
      if (!btn || pinned) return;
      showProductRender(btn.getAttribute("data-sl-product-preview"), btn);
    });
    document.addEventListener("pointerout", function (e) {
      if (pinned) return;
      var btn = e.target.closest && e.target.closest("[data-sl-product-preview]");
      if (!btn || btn.contains(e.relatedTarget)) return;
      hideProductRender();
    });
    document.addEventListener("focusin", function (e) {
      var btn = e.target.closest && e.target.closest("[data-sl-product-preview]");
      if (!btn) return;
      showProductRender(btn.getAttribute("data-sl-product-preview"), btn);
    });
    document.addEventListener("focusout", function (e) {
      if (pinned) return;
      var btn = e.target.closest && e.target.closest("[data-sl-product-preview]");
      if (!btn) return;
      hideProductRender();
    });
    window.addEventListener("scroll", hideProductRender, true);
    window.addEventListener("resize", hideProductRender);
  }

  function StoreLocator(root) {
    this.root = root;
    this.dataUrl = root.getAttribute("data-stores-url");
    this.pinUrl = root.getAttribute("data-pin-url") || "";
    this.stores = [];
    this.filtered = [];
    this.query = "";
    this.stateFilter = "";
    this.productFilter = "";
    this.offset = 0;
    this.ready = false;
    this.mapReady = false;
    this.userCoords = null;
    this.searchOrigin = null;
    this.filterToken = 0;
    this.captureSearch = false;
    this.filterPending = false;
    this.lastSearchKey = "";
    this.lastSearchAt = 0;
    this.searchLogTimer = null;
    this.map = null;
    this.markerLayer = null;
    this.pinsPlotted = false;
    this.mapToken = 0;
    this.form = qs(root, "[data-sl-form]");
    this.input = qs(root, "[data-sl-query]");
    this.stateSelect = qs(root, "[data-sl-state]");
    this.productSelect = qs(root, "[data-sl-product]");
    this.status = qs(root, "[data-sl-status]");
    this.list = qs(root, "[data-sl-list]");
    this.moreBtn = qs(root, "[data-sl-more]");
    this.clearBtn = qs(root, "[data-sl-clear]");
    this.locateBtn = qs(root, "[data-sl-locate]");
    this.loading = qs(root, "[data-sl-loading]");
    this.error = qs(root, "[data-sl-error]");
    this.mapCanvas = qs(root, "[data-sl-map-canvas]");
    this.mapNote = qs(root, "[data-sl-map-note]");
    this.bind();
    this.load();
    this.initMap();
  }

  StoreLocator.prototype.bind = function () {
    var self = this;
    var debounceTimer;
    if (this.form) {
      this.form.addEventListener("submit", function (e) {
        e.preventDefault();
        self.captureSearch = true;
        self.applyFilters(true);
      });
    }
    if (this.input) {
      this.input.addEventListener("input", function () {
        clearTimeout(debounceTimer);
        clearTimeout(self.searchLogTimer);
        debounceTimer = setTimeout(function () {
          self.applyFilters(true);
        }, 280);
        self.searchLogTimer = setTimeout(function () {
          var q = self.input ? self.input.value.trim() : "";
          if (!searchQueryReady(q)) return;
          self.captureSearch = true;
          if (self.query === q && !self.filterPending) self.recordSearch();
          else if (self.query !== q) self.applyFilters(true);
        }, 1200);
      });
    }
    if (this.stateSelect) {
      this.stateSelect.addEventListener("change", function () {
        self.applyFilters(true);
      });
    }
    if (this.productSelect) {
      this.productSelect.addEventListener("change", function () {
        self.applyFilters(true);
      });
    }
    if (this.clearBtn) {
      this.clearBtn.addEventListener("click", function () {
        if (self.input) self.input.value = "";
        if (self.stateSelect) self.stateSelect.value = "";
        if (self.productSelect) self.productSelect.value = "";
        self.userCoords = null;
        self.applyFilters(true);
        if (self.input) self.input.focus();
      });
    }
    if (this.locateBtn) {
      this.locateBtn.addEventListener("click", function () {
        self.useMyLocation();
      });
    }
    if (this.moreBtn) {
      this.moreBtn.addEventListener("click", function () {
        self.renderMore();
      });
    }
    if (this.list) {
      this.list.addEventListener("click", function (e) {
        if (e.target.closest("[data-sl-product-preview], [data-sl-online]")) return;
        var card = e.target.closest("[data-sl-store-id]");
        if (!card) return;
        var id = card.getAttribute("data-sl-store-id");
        self.focusStoreOnMap(id);
      });
    }
  };

  StoreLocator.prototype.initMap = function () {
    var self = this;
    if (!this.mapCanvas) {
      this.mapReady = true;
      return;
    }
    waitForLeaflet(function () {
      if (!window.L) {
        self.mapReady = true;
        return;
      }
      if (self.map) {
        self.mapReady = true;
        return;
      }
      self.map = window.L.map(self.mapCanvas, {
        scrollWheelZoom: false,
        zoomControl: true,
        zoomAnimation: false,
        fadeAnimation: false,
      }).setView(USA_CENTER, USA_ZOOM, { animate: false });
      window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution: "&copy; OpenStreetMap",
      }).addTo(self.map);
      self.markerLayer = window.L.featureGroup().addTo(self.map);
      self.map.on("moveend", function () {
        clearTimeout(self.viewTimer);
        self.viewTimer = setTimeout(function () {
          self.syncListToMap();
        }, 80);
      });
      var mapPane = self.mapCanvas.closest("[data-sl-map]") || self.mapCanvas;
      mapPane.addEventListener(
        "wheel",
        function (event) {
          event.preventDefault();
        },
        { passive: false }
      );
      self.mapReady = true;
      window.addEventListener("resize", function () {
        clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function () {
          self.frameCountry();
        }, 150);
      });
      setTimeout(function () {
        self.map.invalidateSize();
        self.updateMap();
      }, 80);
    });
  };

  StoreLocator.prototype.useMyLocation = function () {
    var self = this;
    if (!navigator.geolocation) {
      if (this.status) this.status.textContent = "Location isn’t available in this browser.";
      return;
    }
    if (this.locateBtn) this.locateBtn.disabled = true;
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.userCoords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        geocodeAddress(self.userCoords.lat + ", " + self.userCoords.lng)
          .then(function () {
            return fetch(
              "https://photon.komoot.io/reverse?lon=" +
                encodeURIComponent(self.userCoords.lng) +
                "&lat=" +
                encodeURIComponent(self.userCoords.lat)
            ).then(function (r) {
              return r.json();
            });
          })
          .then(function (data) {
            var props =
              data && data.features && data.features[0] && data.features[0].properties
                ? data.features[0].properties
                : {};
            var fill = props.postcode || props.city || props.name || "";
            if (self.input && fill) self.input.value = fill;
            self.applyFilters(true);
          })
          .catch(function () {
            self.applyFilters(true);
          })
          .finally(function () {
            if (self.locateBtn) self.locateBtn.disabled = false;
          });
      },
      function () {
        if (self.status)
          self.status.textContent = "Couldn’t access your location. Try entering a ZIP.";
        if (self.locateBtn) self.locateBtn.disabled = false;
      },
      { enableHighAccuracy: false, timeout: 10000 }
    );
  };

  StoreLocator.prototype.load = function () {
    var self = this;
    if (!this.dataUrl) {
      this.showError();
      return;
    }
    fetch(this.dataUrl, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("Failed to load stores");
        return res.json();
      })
      .then(function (data) {
        self.stores = Array.isArray(data.stores) ? data.stores : [];
        self.ready = true;
        self.populateStates();
        self.populateProducts();
        if (self.loading) self.loading.hidden = true;
        if (self.error) self.error.hidden = true;
        self.applyFilters(true);
      })
      .catch(function () {
        if (!self.stores.length) self.showError();
      });
  };

  StoreLocator.prototype.showError = function () {
    if (this.loading) this.loading.hidden = true;
    if (this.error) this.error.hidden = false;
    if (this.status) this.status.textContent = "";
    this.ready = true;
    this.mapReady = true;
  };

  StoreLocator.prototype.populateStates = function () {
    if (!this.stateSelect) return;
    var seen = {};
    var states = [];
    for (var i = 0; i < this.stores.length; i++) {
      var s = this.stores[i].s;
      if (s && !seen[s]) {
        seen[s] = true;
        states.push(s);
      }
    }
    states.sort();
    var frag = document.createDocumentFragment();
    for (var j = 0; j < states.length; j++) {
      var opt = document.createElement("option");
      opt.value = states[j];
      opt.textContent = states[j];
      frag.appendChild(opt);
    }
    this.stateSelect.appendChild(frag);
  };

  StoreLocator.prototype.populateProducts = function () {
    if (!this.productSelect) return;
    var seen = {};
    var products = [];
    for (var i = 0; i < this.stores.length; i++) {
      var list = storeProducts(this.stores[i]);
      for (var j = 0; j < list.length; j++) {
        var p = list[j];
        if (p && !seen[p]) {
          seen[p] = true;
          products.push(p);
        }
      }
    }
    products.sort();
    var frag = document.createDocumentFragment();
    for (var k = 0; k < products.length; k++) {
      var opt = document.createElement("option");
      opt.value = products[k];
      opt.textContent = products[k];
      frag.appendChild(opt);
    }
    this.productSelect.appendChild(frag);
  };

  StoreLocator.prototype.passesProductFilter = function (store) {
    if (!this.productFilter) return true;
    var products = storeProducts(store);
    for (var i = 0; i < products.length; i++) {
      if (products[i] === this.productFilter) return true;
    }
    return false;
  };

  StoreLocator.prototype.matchStore = function (store, query, stateFilter) {
    if (stateFilter && store.s !== stateFilter) return false;
    if (!this.passesProductFilter(store)) return false;
    if (!query) return !!(stateFilter || this.productFilter);
    var qZip = query.replace(/\D/g, "");
    var looksLikeZip2 =
      /^\d{3,5}(-\d{0,4})?$/.test(query.replace(/\s+/g, "")) ||
      (qZip.length >= 3 && qZip.length <= 9 && /^\d[\d\s-]*$/.test(query));
    if (looksLikeZip2 && qZip.length >= 3) {
      var storeZip = zipDigits(store.z);
      if (storeZip.indexOf(qZip.slice(0, 5)) === 0 || storeZip.slice(0, qZip.length) === qZip)
        return true;
      if (qZip.length >= 5) return false;
    }
    var hay = normalize(
      [store.n, store.a, store.a2, store.c, store.s, store.z]
        .concat(storeProducts(store))
        .join(" ")
    );
    var tokens = normalize(query).split(" ").filter(Boolean);
    for (var i = 0; i < tokens.length; i++) {
      if (hay.indexOf(tokens[i]) === -1) return false;
    }
    return tokens.length > 0;
  };

  StoreLocator.prototype.storesNear = function (origin) {
    var matches = [];
    for (var i = 0; i < this.stores.length; i++) {
      var store = this.stores[i];
      if (this.stateFilter && store.s !== this.stateFilter) continue;
      if (!this.passesProductFilter(store)) continue;
      var point = storePoint(store);
      if (!point) continue;
      var miles = milesBetween(origin, point);
      if (miles > SEARCH_RADIUS_MILES) continue;
      store._miles = miles;
      matches.push(store);
    }
    matches.sort(function (a, b) {
      return (a._miles || 0) - (b._miles || 0);
    });
    if (matches.length > MAX_RESULTS) matches = matches.slice(0, MAX_RESULTS);
    return matches;
  };

  StoreLocator.prototype.storesByText = function () {
    var matches = [];
    for (var i = 0; i < this.stores.length; i++) {
      var store = this.stores[i];
      store._miles = null;
      if (this.matchStore(store, this.query, this.stateFilter)) {
        matches.push(store);
        if (matches.length >= MAX_RESULTS) break;
      }
    }
    return matches;
  };

  StoreLocator.prototype.applyFilters = function (reset) {
    if (!this.ready) return;
    var self = this;
    this.query = this.input ? this.input.value.trim() : "";
    this.stateFilter = this.stateSelect ? this.stateSelect.value : "";
    this.productFilter = this.productSelect ? this.productSelect.value : "";
    var loggedQuery = this.query;
    var hasQuery = !!this.query;
    var hasState = !!this.stateFilter;
    var hasProduct = !!this.productFilter;
    var token = ++this.filterToken;
    if (!hasQuery) this.captureSearch = false;
    if (!hasQuery && !hasState && !hasProduct && !this.userCoords) {
      this.filterPending = false;
      this.searchOrigin = null;
      if (reset) this.offset = 0;
      this.updateMap();
      this.syncListToMap();
      return;
    }
    this.filterPending = true;
    var originPromise = Promise.resolve(null);
    if (hasQuery) originPromise = geocodeQuery(this.query);
    else if (this.userCoords) originPromise = Promise.resolve(this.userCoords);
    originPromise.then(function (origin) {
      if (token !== self.filterToken) return;
      self.filterPending = false;
      if (origin) {
        self.searchOrigin = origin;
        self.updateMap();
      } else if (hasQuery) {
        self.searchOrigin = null;
        self.filtered = self.storesByText();
        if (reset) self.offset = 0;
        self.render();
        if (self.captureSearch) self.recordSearch(loggedQuery);
        return;
      }
      if (reset) self.offset = 0;
      self.syncListToMap();
      if (self.captureSearch && hasQuery) self.recordSearch(loggedQuery);
    });
  };

  StoreLocator.prototype.recordSearch = function (query) {
    query = String(query != null ? query : this.query || "").trim().slice(0, 120);
    if (!query) {
      this.captureSearch = false;
      return;
    }
    var payload = {
      query: query,
      state: this.stateFilter || "",
      product: this.productFilter || "",
      results: this.filtered ? this.filtered.length : 0,
    };
    var key = payload.query + "|" + payload.state + "|" + payload.product;
    var now = Date.now();
    this.captureSearch = false;
    if (this.lastSearchKey === key && now - this.lastSearchAt < 30000) return;
    this.lastSearchKey = key;
    this.lastSearchAt = now;
    publishLocatorSearch(payload);
  };

  function popupContent(store) {
    return (
      '<div class="store-locator-finder__popup-body"><strong>' +
      escapeHtml(store.n) +
      "</strong><br>" +
      escapeHtml(storeAddress(store)) +
      (typeof store._miles == "number" ? "<br>" + store._miles.toFixed(1) + " miles away" : "") +
      popupProductsHtml(store) +
      '<br><a href="' +
      escapeHtml(mapsUrl(store)) +
      '" data-sl-track="map_link" data-sl-retailer="google_maps" data-sl-store="' +
      escapeHtml(store.n) +
      '" target="_blank" rel="noopener noreferrer">Open in Google Maps</a></div>'
    );
  }

  var DotLayer = null;

  function ensureDotLayer() {
    if (DotLayer || !window.L) return;
    DotLayer = window.L.Layer.extend({
      initialize: function (locator) {
        this.locator = locator;
      },
      onAdd: function (map) {
        this._map = map;
        this._canvas = document.createElement("canvas");
        this._canvas.className = "store-locator-finder__dots";
        this._canvas.style.pointerEvents = "none";
        map.getPanes().overlayPane.appendChild(this._canvas);
        map.on("moveend zoomend viewreset resize", this._schedule, this);
        this._schedule();
      },
      onRemove: function (map) {
        map.off("moveend zoomend viewreset resize", this._schedule, this);
        if (this._frame) cancelAnimationFrame(this._frame);
        this._frame = 0;
        if (this._canvas && this._canvas.parentNode) this._canvas.parentNode.removeChild(this._canvas);
        this._canvas = null;
      },
      _schedule: function () {
        var self = this;
        if (this._frame) return;
        this._frame = requestAnimationFrame(function () {
          self._frame = 0;
          self._draw();
        });
      },
      _draw: function () {
        var map = this._map;
        var canvas = this._canvas;
        if (!map || !canvas) return;
        var size = map.getSize();
        var dpr = window.devicePixelRatio || 1;
        canvas.width = Math.max(1, Math.round(size.x * dpr));
        canvas.height = Math.max(1, Math.round(size.y * dpr));
        canvas.style.width = size.x + "px";
        canvas.style.height = size.y + "px";
        window.L.DomUtil.setPosition(canvas, map.containerPointToLayerPoint([0, 0]));
        var ctx = canvas.getContext("2d");
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, size.x, size.y);
        var stores = this.locator.dotStores || [];
        ctx.fillStyle = "#d62237";
        ctx.strokeStyle = "#ffffff";
        ctx.lineWidth = 1;
        for (var i = 0; i < stores.length; i++) {
          var point = storePoint(stores[i]);
          if (!point) continue;
          var p = map.latLngToContainerPoint([point.lat, point.lng]);
          ctx.beginPath();
          ctx.arc(p.x, p.y, 3.5, 0, Math.PI * 2);
          ctx.fill();
          ctx.stroke();
        }
      },
    });
  }

  StoreLocator.prototype.storeById = function (storeId) {
    var id = String(storeId);
    for (var i = 0; i < this.stores.length; i++) {
      if (String(this.stores[i].id) === id) return this.stores[i];
    }
    return null;
  };

  StoreLocator.prototype.clearMarkers = function () {
    if (this.markerLayer) this.markerLayer.clearLayers();
  };

  StoreLocator.prototype.showDots = function (stores) {
    this.dotStores = stores;
    ensureDotLayer();
    if (!this.map || !DotLayer) return;
    if (!this.dotLayer) {
      this.dotLayer = new DotLayer(this);
      this.dotLayer.addTo(this.map);
      return;
    }
    if (this.dotLayer._schedule) this.dotLayer._schedule();
  };

  StoreLocator.prototype.hideDots = function () {
    this.dotStores = [];
    if (this.dotLayer && this.dotLayer._schedule) this.dotLayer._schedule();
  };

  StoreLocator.prototype.plotMarkers = function (stores) {
    this.clearMarkers();
    if (!this.markerLayer || !window.L) return;
    var icon = getPinIcon(this.pinUrl);
    var popupOptions = {
      maxWidth: 300,
      minWidth: 220,
      className: "store-locator-finder__leaflet-popup",
    };
    for (var i = 0; i < stores.length; i++) {
      var store = stores[i];
      var point = storePoint(store);
      if (!point) continue;
      var marker = window.L.marker([point.lat, point.lng], {
        icon: icon,
        title: store.n,
      });
      marker.bindPopup(popupContent.bind(null, store), popupOptions);
      marker._storeId = String(store.id);
      this.markerLayer.addLayer(marker);
    }
    if (this.mapNote) this.mapNote.hidden = true;
  };

  StoreLocator.prototype.syncPins = function () {
    if (!this.map || !this.markerLayer) return;
    this.pinsPlotted = true;
    var stores = this.filtered || [];
    if (stores.length > MARKER_CAP) {
      this.clearMarkers();
      this.showDots(stores);
    } else {
      this.hideDots();
      this.plotMarkers(stores);
    }
    this.openFocusedPopup();
  };

  StoreLocator.prototype.openFocusedPopup = function () {
    if (!this.focusId || !this.map) return;
    var id = this.focusId;
    this.focusId = "";
    var found = null;
    if (this.markerLayer) {
      this.markerLayer.eachLayer(function (layer) {
        if (String(layer._storeId) === id) found = layer;
      });
    }
    if (found) {
      found.openPopup();
      return;
    }
    var store = this.storeById(id);
    var point = storePoint(store);
    if (!store || !point) return;
    window.L.popup({
      maxWidth: 300,
      minWidth: 220,
      className: "store-locator-finder__leaflet-popup",
    })
      .setLatLng([point.lat, point.lng])
      .setContent(popupContent(store))
      .openOn(this.map);
  };

  StoreLocator.prototype.updateMap = function () {
    if (!this.map || !this.markerLayer) {
      this.initMap();
      return;
    }
    this.map.invalidateSize();
    if (this.mapNote) this.mapNote.hidden = true;
    var focus = this.searchOrigin || this.userCoords;
    if (focus) {
      this.map.setView([focus.lat, focus.lng], SEARCH_ZOOM);
      return;
    }
    this.frameCountry();
  };

  StoreLocator.prototype.frameCountry = function () {
    var self = this;
    if (!this.map || this.searchOrigin || this.userCoords) return;
    var fit = function () {
      if (!self.map || self.searchOrigin || self.userCoords) return;
      self.map.invalidateSize({ animate: false });
      if (self.map.stop) self.map.stop();
      var bounds = window.L.latLngBounds([]);
      for (var i = 0; i < self.stores.length; i++) {
        var point = storePoint(self.stores[i]);
        if (point) bounds.extend([point.lat, point.lng]);
      }
      if (bounds.isValid()) {
        self.map.fitBounds(bounds, { padding: [20, 20], maxZoom: USA_ZOOM, animate: false });
      } else {
        self.map.setView(USA_CENTER, USA_ZOOM, { animate: false });
      }
    };
    fit();
    clearTimeout(this.countryTimer);
    this.countryTimer = setTimeout(fit, 400);
  };

  StoreLocator.prototype.storesInView = function () {
    var bounds = this.map.getBounds();
    var center = this.map.getCenter();
    var viewOrigin = { lat: center.lat, lng: center.lng };
    var milesFrom = this.searchOrigin || this.userCoords || viewOrigin;
    var matches = [];
    for (var i = 0; i < this.stores.length; i++) {
      var store = this.stores[i];
      if (this.stateFilter && store.s !== this.stateFilter) continue;
      if (!this.passesProductFilter(store)) continue;
      var point = storePoint(store);
      if (!point || !bounds.contains([point.lat, point.lng])) continue;
      store._miles = milesBetween(milesFrom, point);
      store._viewRank = milesBetween(viewOrigin, point);
      matches.push(store);
    }
    matches.sort(function (a, b) {
      return a._viewRank - b._viewRank;
    });
    return matches;
  };

  StoreLocator.prototype.syncListToMap = function () {
    if (!this.ready || !this.map) return;
    this.pinsPlotted = true;
    this.stateFilter = this.stateSelect ? this.stateSelect.value : "";
    this.productFilter = this.productSelect ? this.productSelect.value : "";
    this.filtered = this.storesInView();
    this.offset = 0;
    this.render();
    this.syncPins();
    var map = this.map;
    requestAnimationFrame(function () {
      if (map) map.invalidateSize({ animate: false });
    });
  };

  StoreLocator.prototype.focusStoreOnMap = function (storeId) {
    var store = this.storeById(storeId);
    var point = storePoint(store);
    if (!store || !point || !this.map || !window.L) return;
    this.focusId = String(storeId);
    var latlng = window.L.latLng(point.lat, point.lng);
    var zoom = Math.max(this.map.getZoom(), 14);
    if (this.map.getZoom() === zoom && this.map.getCenter().equals(latlng)) {
      this.openFocusedPopup();
      return;
    }
    this.map.setView(latlng, zoom);
  };

  StoreLocator.prototype.renderStatus = function () {
    if (!this.status) return;
    if (!this.filtered.length) {
      var zoomedIn = this.map && this.pinsPlotted && this.map.getZoom() > USA_ZOOM;
      this.status.textContent = zoomedIn
        ? "No stores in this map view. Zoom out or pan to find more."
        : "Zoom in on the map, or search a ZIP, city, or address.";
      return;
    }
    var countLabel = this.filtered.length.toLocaleString();
    this.status.textContent =
      countLabel + (this.filtered.length === 1 ? " store" : " stores") + " in this map view.";
  };

  StoreLocator.prototype.ensureMoreButton = function () {
    if (this.moreBtn || !this.list || !this.list.parentNode) return;
    var wrap = document.createElement("div");
    wrap.className = "store-locator-finder__more-wrap";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "store-locator-finder__more";
    btn.setAttribute("data-sl-more", "");
    btn.hidden = true;
    btn.textContent = "Show more stores";
    wrap.appendChild(btn);
    this.list.parentNode.appendChild(wrap);
    this.moreBtn = btn;
    var self = this;
    btn.addEventListener("click", function () {
      self.renderMore();
    });
  };

  StoreLocator.prototype.updateMoreButton = function () {
    if (!this.moreBtn) return;
    this.moreBtn.hidden = this.offset >= this.filtered.length;
  };

  StoreLocator.prototype.renderCard = function (store) {
    var city = titleCaseCity(store.c);
    var fullAddr =
      escapeHtml(store.a) +
      (store.a2 ? ", " + escapeHtml(store.a2) : "") +
      ", " +
      escapeHtml(city) +
      ", " +
      escapeHtml(store.s) +
      " " +
      escapeHtml(store.z);
    var details =
      '<a class="store-locator-finder__details" href="' +
      escapeHtml(mapsUrl(store)) +
      '" data-sl-track="store_link" data-sl-retailer="google_maps" data-sl-store="' +
      escapeHtml(store.n) +
      '" target="_blank" rel="noopener noreferrer">View details <span aria-hidden="true">&#8250;</span></a>';
    var products = productsHtml(store);
    var stock =
      storeProducts(store).length > 0
        ? '<p class="store-locator-finder__stock"><span class="store-locator-finder__stock-dot"></span> Products listed below</p>'
        : '<p class="store-locator-finder__stock"><span class="store-locator-finder__stock-dot"></span> In stock</p>';
    return (
      '<li class="store-locator-finder__item" data-sl-store-id="' +
      escapeHtml(String(store.id)) +
      '"><article class="store-locator-finder__card"><div class="store-locator-finder__card-mark" aria-hidden="true">' +
      escapeHtml(storeInitials(store.n)) +
      '</div><div class="store-locator-finder__card-body"><h3 class="store-locator-finder__name">' +
      escapeHtml(store.n) +
      '</h3><p class="store-locator-finder__addr">' +
      fullAddr +
      "</p>" +
      (typeof store._miles == "number"
        ? '<p class="store-locator-finder__distance">' + store._miles.toFixed(1) + " miles away</p>"
        : "") +
      stock +
      products +
      "</div>" +
      details +
      "</article></li>"
    );
  };

  StoreLocator.prototype.render = function () {
    this.renderStatus();
    if (!this.list) return;
    this.ensureMoreButton();
    if (!this.filtered.length) {
      var zoomedIn = this.map && this.pinsPlotted && this.map.getZoom() > USA_ZOOM;
      this.list.innerHTML = zoomedIn
        ? '<li class="store-locator-finder__empty">No stores in this map view. Zoom out or pan to find more.</li>'
        : '<li class="store-locator-finder__empty">Zoom in on the map, or search a ZIP, city, or address.</li>';
      this.offset = 0;
      this.updateMoreButton();
      return;
    }
    var count = Math.min(PAGE_SIZE, this.filtered.length);
    var html = "";
    for (var i = 0; i < count; i++) html += this.renderCard(this.filtered[i]);
    this.list.innerHTML = html;
    this.offset = count;
    this.updateMoreButton();
  };

  StoreLocator.prototype.renderMore = function () {
    if (!this.list) return;
    var next = Math.min(this.offset + PAGE_SIZE, this.filtered.length);
    var html = "";
    for (var i = this.offset; i < next; i++) html += this.renderCard(this.filtered[i]);
    this.list.insertAdjacentHTML("beforeend", html);
    this.offset = next;
    this.updateMoreButton();
  };

  function ensureProductFilter(root) {
    if (qs(root, "[data-sl-product]")) return;
    var toolbar = qs(root, ".store-locator-finder__toolbar");
    if (!toolbar) return;
    var state = qs(toolbar, "[data-sl-state]");
    var wrap = document.createElement("label");
    wrap.className = "store-locator-finder__label";
    wrap.setAttribute("for", "StoreLocatorProduct");
    wrap.textContent = "Product";
    var select = document.createElement("select");
    select.id = "StoreLocatorProduct";
    select.className = "store-locator-finder__select store-locator-finder__select--product";
    select.setAttribute("data-sl-product", "");
    select.setAttribute("aria-label", "Filter by product");
    var opt = document.createElement("option");
    opt.value = "";
    opt.textContent = "All products";
    select.appendChild(opt);
    if (state && state.parentNode === toolbar) {
      toolbar.insertBefore(wrap, state.nextSibling);
      toolbar.insertBefore(select, wrap.nextSibling);
    } else {
      toolbar.insertBefore(select, toolbar.firstChild);
      toolbar.insertBefore(wrap, select);
    }
  }

  function init() {
    bindClickTracking();
    bindProductRender();
    var nodes = document.querySelectorAll("[data-store-locator-finder]");
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute("data-sl-init") === "1") continue;
      ensureProductFilter(nodes[i]);
      nodes[i].setAttribute("data-sl-init", "1");
      new StoreLocator(nodes[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
